import React from 'react';
import PropTypes from 'prop-types';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../utils/behaviorSettings';
import GiftBoxIcon from '../../../public/static/icons/gift_box.svg';
import GingerbreadManIcon from '../../../public/static/icons/gingerbread_man.svg';
import SantaHeadIcon from '../../../public/static/icons/santa_head.svg';

import styles from './index.module.scss';

const ItemIcon = ({ icon }) => {
  switch (icon) {
    case 'gift_box':
      return <GiftBoxIcon />;
    case 'gingerbread_man':
      return <GingerbreadManIcon />;
    case 'santa_head':
      return <SantaHeadIcon />;
    case 'bauble':
      return <img src="/static/icons/bauble.png" alt="Bauble" width="64" />;
    case 'stars':
      return <img src="/static/icons/stars.png" alt="Stars" width="88" />;
    case 'present':
      return <img src="/static/icons/present.png" alt="Present" width="64" />;
    default:
      return null;
  }
};

const itemIconPropTypes = {
  icon: PropTypes.oneOf(['gift_box', 'gingerbread_man', 'santa_head', 'bauble', 'stars', 'present'])
    .isRequired,
};
ItemIcon.propTypes = itemIconPropTypes;

const GiftsBBListWithIcons = ({
  title = '',
  items,
  style = 'default',
  behaviorSettings = null,
  uuid = null,
}) => {
  const classes = [
    'bb',
    styles['bb-list-with-icons'],
    styles[`bb-list-with-icons--${style}`],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')} id={uuid}>
      {(style === 'christmas' || style === 'yellow-christmas') && (
        <div className={styles['bb-list-with-icons__decorations']}></div>
      )}
      <div className="container">
        <div className={styles['bb-list-with-icons__content']}>
          {!!title && <div className={styles['bb-list-with-icons__title']}>{title}</div>}
          <div className={styles['bb-list-with-icons__items']}>
            {items.map((item) => (
              <div className={styles['bb-list-with-icons__item']} key={item.icon}>
                <div className={styles['bb-list-with-icons__item-icon']}>
                  <ItemIcon icon={item.icon} />
                </div>
                <div className={styles['bb-list-with-icons__item-title']}>{item.title}</div>
                <div className={styles['bb-list-with-icons__item-text']}>{item.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

GiftsBBListWithIcons.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      ...itemIconPropTypes,
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  style: PropTypes.oneOf(['default', 'christmas', 'yellow-christmas']),
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default GiftsBBListWithIcons;
